export default "__VITE_ASSET__D4C2xJLx__"